import { render, staticRenderFns } from "./GlyphChar.vue?vue&type=template&id=e9bab562&scoped=true&"
import script from "./GlyphChar.vue?vue&type=script&lang=js&"
export * from "./GlyphChar.vue?vue&type=script&lang=js&"
import style0 from "./GlyphChar.vue?vue&type=style&index=0&id=e9bab562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bab562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
